import React from "react"
import { Helmet } from 'react-helmet'
import { Link } from 'gatsby'
import Layout from "../components/Layout"
import { StaticImage } from "gatsby-plugin-image"

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGithub } from '@fortawesome/free-brands-svg-icons'
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons'


export default function Proyectos() {
  return (
    <Layout>
      <Helmet>
        <title>Cristóbal Villanueva | Proyectos</title>
      </Helmet>
      <h1 className="titulo">Proyectos</h1>
      <div className="grid-proyectos">
        <div className="card">
          <div className="img-container">
            <Link to="https://vertientes-talcahuano.netlify.app/">
              <StaticImage
                src="../images/vertientes.jpg"
                alt="foto proyecto"
                placeholder="blurred"
                objectFit="cover"
              />
            </Link>
          </div>
          <div className="titulo-proyecto">Página Vertientes</div>
          <ul className="tecnologias-proyecto">
            <li>Python</li>
            <li>React</li>
            <li>Gatsby</li>
          </ul>
          <div className="links-proyecto">
            <div className="live-proyecto">
              <a href="https://vertientes-talcahuano.netlify.app/">
                <FontAwesomeIcon icon={ faExternalLinkAlt }/>
                <span>Link</span>
              </a>
            </div>
            <div className="live-proyecto">
              <a href="https://github.com/crvillanueva/pag-vertientes-talcahuano">
                <FontAwesomeIcon icon={ faGithub }/>
                <span>Repo Link</span>
              </a>
            </div>
          </div>
        </div>
        <div className="card">
          <div className="img-container">
            <Link to="https://pokeapi-card-chartjs.web.app/">
              <StaticImage
                src="../images/pokeapi.jpg"
                alt="foto proyecto"
                placeholder="blurred"
                objectFit="cover"
              />
            </Link>
          </div>
          <div className="titulo-proyecto">Pokemon Stats</div>
          <ul className="tecnologias-proyecto">
            <li>REST API</li>
            <li>JavaScript</li>
            <li>CSS/Sass</li>
            <li>Chart.js</li>
          </ul>
          <div className="links-proyecto">
            <div className="live-proyecto">
              <a href="https://pokeapi-card-chartjs.web.app/">
                <FontAwesomeIcon icon={ faExternalLinkAlt }/>
                <span>Link</span>
              </a>
            </div>
            <div className="live-proyecto">
              <a href="https://github.com/crvillanueva/pokeapi-card-chartjs">
                <FontAwesomeIcon icon={ faGithub }/>
                <span>Repo Link</span>
              </a>
            </div>
          </div>
        </div>
        <div className="card">
          <div className="img-container">
            <Link to="https://github.com/crvillanueva/dash-plotly-geoapps">
              <StaticImage
                src="../images/dashapps.jpg"
                alt="foto proyecto"
                placeholder="blurred"
                objectFit="cover"
              />
            </Link>
          </div>
          <div className="titulo-proyecto">Dash Apps</div>
          <ul className="tecnologias-proyecto">
            <li>Python</li>
            <li>Plotly</li>
            <li>Dash</li>
          </ul>
          <div className="links-proyecto">
            <div className="live-proyecto">
              <a href="https://github.com/crvillanueva/dash-plotly-geoapps">
                <FontAwesomeIcon icon={ faExternalLinkAlt }/>
                <span>Link</span>
              </a>
            </div>
            <div className="live-proyecto">
              <a href="https://github.com/crvillanueva/dash-plotly-geoapps">
                <FontAwesomeIcon icon={ faGithub }/>
                <span>Repo Link</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
}
